import { writable } from 'svelte/store';
import { get } from 'svelte/store';
let defaultData = {
  taskComplianceStatusType: [],
  taskRiskRankType: [],
  task_category: [],
  taskServiceType: [],
  taskActivityTypes: [],
  clients: [],
  units: [],
  users: [],
  isManager: 0,
  fromDate: '',
  toDate: '',
  initialFromDate: '',
  initialToDate: '',
};
export const dashboardData = writable({
  ...defaultData,
});
export const getDashboardData = () => {
  return get(dashboardData);
};
export const setDashboardData = (data) => {
  dashboardData.set(data);
};
export const resetDashboardData = () => {
  dashboardData.set(defaultData);
};
